module.exports = __webpack_public_path__ + "img/logo.78cb7721.png";